export class ResetPasswordRequest {
    constructor(
        public username: string,
        public childMinder: boolean
    ) {
    }
}
